import React, { Component } from 'react'
import Axios from 'axios';

class Home extends Component {
    state = {
        // users: [{ email: '', fullname: '', username: '', password:''}]
        users: []
    }

    componentDidMount() {
        // Axios.get("http://18.211.62.105:7822/apartmynts/api/v1/user/update-user")
        // Axios.get("http://localhost:8080/users")
        // .then(result => {
            // console.log(result);

            // this.setState({
            //     users: result.data
            // });
        // });
    }

    toggleComplete = (index) => {
        // const user = this.state.users[index];    or
        
        const { users } = this.state;
        const user = users[index];

        // const newUsers = this.state.users.map((user, i) => {
        const newUsers = users.map((user, i) => {
            if(index === i) {
                return {
                    ...user,
                    completed: !user.complete
                };
            }
            return user;
        });

        Axios.put("http://localhost:8080/users/" + user.id, {
            ...user,
            completed: !user.completed
        })
        .then(() => {
            this.setState({
                users: newUsers
            });
        });
    };

    addUsers = (text) => {
        Axios.post("http://localhost:8080/users", {
            // text: text
            text
        })
        .then((result) => {
            const newUsers = this.state.users.concat({
                text
            });

            this.setState({
                users: newUsers
            });
        });
    };

    editUsers = (index, newText) => {
        // const { users, email, fullname, username, password } = this.state;
        const { users } = this.state;
        const user = users[index];

        // Axios.put("http://18.211.62.105:7822/apartmynts/api/v1/user/update-user/", { email, fullname, username, password})
        Axios.post("http://localhost:8080/users/" + user.id, {
            ...user,
            completed: !user.completed
        })
        .then(() => {
            const newUsers = users.map((user, i) => {
                if (index === i) {
                    return {
                        ...user,
                        text: newText
                    };
                }
    
                return user;
            });
    
            this.setState({
                users: newUsers
            });
        });

    };

    deleteUser = (index) => {
        const { users } = this.state;
        const user = users[index];

        Axios.delete("http://localhost:8080/users/" + user.id)
        .then(() => {
            const newUsers = users.filter((user, i) => {
                return index === i ? false : true;
            });

            this.setState({
                users: newUsers
            });
        });
    };

  render() {
    //   const { user } = this.props;

    return (
      <>
        <h1>Home Page</h1>
        {/* <li
        className={user.completed ? "completed" : ""}
        >
            <span>
                <button
                onClick={this.clickHandler}
                >
                {user.text}
                </button>
            </span>

            <span>
                <button
                onClick={this.editUsers}
                >
                Edit
                </button>
                <button
                onClick={this.deleteUser}
                >
                Delete
                </button>
            </span>
        </li> */}
      </>
    )
  }
}

export default Home;
